import moment from "moment";
import { createPosmw, enableService, addActiveVendor } from 'src/javascripts/gaa/postData';
import { updatePosmw, updatePosDvrSetting } from 'src/javascripts/gaa/updateData';
import { removeActiveVendor } from 'src/javascripts/gaa/deleteData';
import UberEatImg from 'src/assets/img/gaa-other/UberEats.png';
import FoodPandaImg from 'src/assets/img/gaa-other/Foodpanda.png';
import LineSpotImg from 'src/assets/img/gaa-other/LineSpot.png';
import GoFoodieImg from 'src/assets/img/gaa-other/GoFoodie.png';
import IDOOImg from 'src/assets/img/gaa-other/IDOO.png';
import LaFreshImg from 'src/assets/img/gaa-other/LaFresh.png';
import GSImg from 'src/assets/img/gaa-other/GS.png';
import TTPUSHImg from 'src/assets/img/gaa-other/TTPUSH.png';
import CupImg from 'src/assets/img/gaa-other/Cup.png';
import APPImg from 'src/assets/img/gaa-other/APP.png';


export class App {
    displayName;
    vendorCode;
    img;
    appType;
    popType;
    active;
    entrys;
    rawData;
    constructor(displayName, vendorCode, img, appType, popType) {
        this.displayName = displayName;
        this.vendorCode = vendorCode;
        this.img = img;
        this.appType = appType;
        this.popType = popType;
        this.active = true;
        this.entrys = {};
        this.buttons = {
            delete: false
        };
    }

    copy() {
        const clone = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
        clone.entrys = JSON.parse(JSON.stringify(this.entrys));
        return clone;
    }

    setData(data) {
        this.rawData = data;
    }

    action() {}

    setEntryValue(key, value) {
        if (typeof value === 'undefined') value = '';
        this.entrys[key].value = value;
    }

    getEntrysValue(key) {
        return this.entrys[key].value;
    }
}

export class UbereatsPro extends App {
    enable;
    id;
    constructor() {
        super("UberEats Pro", "ubereats", UberEatImg, "takeOrderPlatform", "default");
        this.enable = false;
        this.entrys = {
            'UberEat UUID': { value: '', type: 'input' },
            '串接key設定': { value: true, type: 'checkbox' },
            'Client ID': { value: '', type: 'input' },
            'Client Secret': { value: '', type: 'input' },
            '樣板ID': { value: '', type: 'input' }
        };
        this.buttons = {
            delete: true
        }
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        this.setEntryValue('UberEat UUID', data.vendorShopId);
        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
            this.setEntryValue('Client ID', '');
            this.setEntryValue('Client Secret', '');
        } else {
            this.setEntryValue('串接key設定', false);
            this.setEntryValue('Client ID', data.authData.clientId);
            this.setEntryValue('Client Secret', data.authData.clientSecret);
        }
        if (data.options) {
            this.setEntryValue('樣板ID', data.options.templateId);
        }
    }   
    
    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {
            clientId: this.getEntrysValue('Client ID'),
            clientSecret: this.getEntrysValue('Client Secret')
        }
        const templateId = parseInt(this.getEntrysValue('樣板ID'));
        const options = {
            templateId: isNaN(templateId)? undefined: templateId
        }
        const data = {
            authData,
            options,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('UberEat UUID'),
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class FoodpandaPro extends App {
    enable;
    id;
    constructor(accountId) {
        super('Foodpanda Pro', 'foodpanda', FoodPandaImg, 'takeOrderPlatform', 'default');
        this.enable = false;
        this.entrys = {
            'TW- + 餐廳Code': { value: '', type: 'input', ps: '例如: TW-abcd123' },
            '串接key設定': { value: true, type: 'checkbox' },
            'Username': { value: '', type: 'input' },
            'Password': { value: '', type: 'input' },
            'Chain Code': { value: 'dotdotchain', type: 'input' },
            'Vendor ID': { value: `${accountId}`, type: 'input' },
            '樣板ID': { value: '', type: 'input' },
        };
        this.buttons = {
            delete: true
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        this.setEntryValue('TW- + 餐廳Code', data.vendorShopId);
        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
            this.setEntryValue('Username', '');
            this.setEntryValue('Password', '');
        } else {
            this.setEntryValue('串接key設定', false);
            this.setEntryValue('Username', data.authData.username);
            this.setEntryValue('Password', data.authData.password);
        }
        if (data.options) {
            this.setEntryValue('Chain Code', data.options.chainCode);
            this.setEntryValue('Vendor ID', data.options.chainVendorId);
            this.setEntryValue('樣板ID', data.options.templateId);
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {
            username: this.getEntrysValue('Username'),
            password: this.getEntrysValue('Password')
        }
        const templateId = parseInt(this.getEntrysValue('樣板ID'));
        const options = {
            chainCode: this.getEntrysValue('Chain Code'),
            chainVendorId: this.getEntrysValue('Vendor ID'),
            templateId: isNaN(templateId)? undefined: templateId
        }
        const data = {
            authData,
            options,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('TW- + 餐廳Code'),
            env: 'production'
        }
        
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class UberEatsLite extends App {
    enable;
    id;
    constructor() {
        super('UberEats Lite', 'ubereats-lite', UberEatImg, 'takeOrderPlatform', 'default');
        this.active = false;
        this.enable = false;
        this.entrys = {
            '開通': { value: this.active, type: 'switch' },
            'UberEat UUID': { value: '', type: 'input' },
            '串接key設定': { value: true, type: 'checkbox' },
            'Client ID': { value: '', type: 'input' },
            'Client Secret': { value: '', type: 'input' },
            '樣板ID': { value: '', type: 'input' },
            '加購列印樣式': { value: '', type: 'tabs' , ps: '預設為橫列',
                tabOptions: [
                    { label: '直列', value: 'straight' },
                    { label: '橫列', value: 'row' },
                ]
            }
        };
        this.buttons = {
            delete: true
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        this.setEntryValue('UberEat UUID', data.vendorShopId);
        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
            this.setEntryValue('Client ID', '');
            this.setEntryValue('Client Secret', '');
        } else {
            this.setEntryValue('串接key設定', false);
            this.setEntryValue('Client ID', data.authData.clientId);
            this.setEntryValue('Client Secret', data.authData.clientSecret);
        }
        if (data.options) {
            this.setEntryValue('樣板ID', data.options.templateId);
            this.setEntryValue('加購列印樣式', data.options.qpPrinterOptionType);
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {
            clientId: this.getEntrysValue('Client ID'),
            clientSecret: this.getEntrysValue('Client Secret')
        }
        const templateId = parseInt(this.getEntrysValue('樣板ID'));
        const options = {
            qpPrinterOptionType: this.getEntrysValue('加購列印樣式'),
            templateId: isNaN(templateId)? undefined: templateId
        }
        const data = {
            authData,
            options,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('UberEat UUID'),
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }

    setActive(value) {
        this.active = value;
        this.setEntryValue('開通', value);
    }

    switchEntryOnChange(key, accountId) {
        if (key !== '開通') return;
        const changeValue = this.getEntrysValue(key);
        this.setActive(changeValue);
        if (changeValue) return addActiveVendor(accountId, this.vendorCode);
        return removeActiveVendor(accountId, this.vendorCode);
    }
}

export class FoodpandaLite extends App {
    enable;
    id;
    constructor(accountId) {
        super('Foodpanda Lite', 'foodpanda-lite', FoodPandaImg, 'takeOrderPlatform', 'default');
        this.active = false;
        this.enable = false;
        this.entrys = {
            '開通': { value: this.active, type: 'switch' },
            'TW- + 餐廳Code': { value: '', type: 'input', ps: '例如: TW-abcd123' },
            '串接key設定': { value: true, type: 'checkbox' },
            'Username': { value: '', type: 'input' },
            'Password': { value: '', type: 'input' },
            'Chain Code': { value: 'dotdotchain', type: 'input' },
            'Vendor ID': { value: `${accountId}`, type: 'input' },
            '樣板ID': { value: '', type: 'input' },
            '加購列印樣式': { value: '', type: 'tabs' , ps: '預設為橫列',
                tabOptions: [
                    { label: '直列', value: 'straight' },
                    { label: '橫列', value: 'row' },
                ]
            }
        };
        this.buttons = {
            delete: true
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        this.setEntryValue('TW- + 餐廳Code', data.vendorShopId);
        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
            this.setEntryValue('Username', '');
            this.setEntryValue('Password', '');
        } else {
            this.setEntryValue('串接key設定', false);
            this.setEntryValue('Username', data.authData.username);
            this.setEntryValue('Password', data.authData.password);
        }
        if (data.options) {
            this.setEntryValue('Chain Code', data.options.chainCode);
            this.setEntryValue('Vendor ID', data.options.chainVendorId);
            this.setEntryValue('樣板ID', data.options.templateId);
            this.setEntryValue('加購列印樣式', data.options.qpPrinterOptionType);
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {
            username: this.getEntrysValue('Username'),
            password: this.getEntrysValue('Password')
        }
        const templateId = parseInt(this.getEntrysValue('樣板ID'));
        const options = {
            chainCode: this.getEntrysValue('Chain Code'),
            chainVendorId: this.getEntrysValue('Vendor ID'),
            templateId: isNaN(templateId)? undefined: templateId,
            qpPrinterOptionType: this.getEntrysValue('加購列印樣式'),
        }
        const data = {
            authData,
            options,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('TW- + 餐廳Code'),
            env: 'production'
        }
        
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }

    setActive(value) {
        this.active = value;
        this.setEntryValue('開通', value);
    }

    switchEntryOnChange(key, accountId) {
        if (key !== '開通') return;
        const changeValue = this.getEntrysValue(key);
        this.setActive(changeValue);
        if (changeValue) return addActiveVendor(accountId, this.vendorCode);
        return removeActiveVendor(accountId, this.vendorCode);
    }
}

export class LineSpot extends App {
    enable;
    id;
    constructor(accountId) {
        super('Line Spot', 'linespot', LineSpotImg, 'takeOrderPlatform', 'default');
        this.enable = false;
        this.entrys = {
            '本店ID': { value: `${accountId}`, type: 'input' },
            '串接key設定': { value: true, type: 'checkbox', disabled: true },
        };
        this.buttons = {
            delete: false
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        this.setEntryValue('本店ID', data.vendorShopId);
        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
        } else {
            this.setEntryValue('串接key設定', false);
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {};
        const options = {};
        const data = {
            authData,
            options,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('本店ID'),
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class Gofoodie extends App {
    enable;
    id;
    constructor() {
        super('GoFoodie', 'gofoodie', GoFoodieImg, 'takeOrderPlatform', 'default');
        this.enable = false;
        this.entrys = {
            'GoFoodie商店 ID': { value: '', type: 'input', ps: '(P_xxxx)' },
            '串接key設定': { value: true, type: 'checkbox', disabled: true },
            '內用樣板ID': { value: '', type: 'input' },
            '自取樣板ID': { value: '', type: 'input' },
            '外送樣板ID': { value: '', type: 'input' },
        };
        this.buttons = {
            delete: false
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        this.setEntryValue('GoFoodie商店 ID', data.vendorShopId);
        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
        } else {
            this.setEntryValue('串接key設定', false);
        }
        if (data.options) {
            this.setEntryValue('內用樣板ID', data.options.eatInTemplateId);
            this.setEntryValue('自取樣板ID', data.options.togoTemplateId);
            this.setEntryValue('外送樣板ID', data.options.deliveryTemplateId);
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {};
        const eatInTemplateId = this.getEntrysValue('內用樣板ID');
        const togoTemplateId = this.getEntrysValue('自取樣板ID');
        const deliveryTemplateId = this.getEntrysValue('外送樣板ID'); 
        const options = {
            eatInTemplateId, togoTemplateId, deliveryTemplateId,
            templateFormulas: eatInTemplateId&&togoTemplateId&&deliveryTemplateId ? [{"derivation":"{{IF(mealType === 'eatIn', 1, 0)}}","name":"isEatIn","function":"eval"},{"derivation":"{{IF(mealType === 'toGo', 1, 0)}}","name":"isToGo","function":"eval"},{"derivation":"{{IF(mealType === 'delivery', 1, 0)}}","name":"isDelivery","function":"eval"},{"derivation":`{{(formulaResults.isEatIn * ${eatInTemplateId}) || (formulaResults.isToGo * ${togoTemplateId}) || (formulaResults.isDelivery * ${deliveryTemplateId})}}`,"name":"templateId","function":"eval"}] : undefined
        };
        const data = {
            authData,
            options,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('GoFoodie商店 ID'),
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class Idoo extends App {
    enable;
    id;
    constructor(accountId) {
        super('IDOO', 'counter', IDOOImg, 'additionServices', 'default');
        this.enable = false;
        this.entrys = {
            '本店ID': { value: `${accountId}`, type: 'input'},
            '串接key設定': { value: true, type: 'checkbox', disabled: true },
            '內用樣板ID': { value: '', type: 'input' },
            '自取樣板ID': { value: '', type: 'input' },
            '外送樣板ID': { value: '', type: 'input' },
            // QC-3316: 訂單調帳開關(預設開)+ 管理員帳號(下拉,選項於點開卡片時載入接單機帳號)
            '訂單調帳開關': { value: true, type: 'checkbox', text: '開啟訂單調帳' },
            '管理員帳號': { value: '', type: 'select', options: [], ps: '設定後 iDOO 端調帳前需輸入該帳號密碼;留空=免密碼' },
        };
        this.buttons = {
            delete: false
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        this.setEntryValue('本店ID', data.vendorShopId);
        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
        } else {
            this.setEntryValue('串接key設定', false);
        }
        if (data.options) {
            this.setEntryValue('內用樣板ID', data.options.eatInTemplateId);
            this.setEntryValue('自取樣板ID', data.options.togoTemplateId);
            this.setEntryValue('外送樣板ID', data.options.deliveryTemplateId);
            // QC-3316: 讀既有開關/管理員(未設 → 開關預設開、管理員空)
            this.setEntryValue('訂單調帳開關', data.options.adjustmentEnabled === false ? false : true);
            this.setEntryValue('管理員帳號', data.options.adjustmentAdminUserId ? String(data.options.adjustmentAdminUserId) : '');
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {};
        const eatInTemplateId = this.getEntrysValue('內用樣板ID');
        const togoTemplateId = this.getEntrysValue('自取樣板ID');
        const deliveryTemplateId = this.getEntrysValue('外送樣板ID');
        // QC-3316: 調帳開關 + 管理員(select 值為字串 → 存 number 或 null)
        const adjustmentEnabled = this.getEntrysValue('訂單調帳開關') ? true : false;
        const adminRaw = this.getEntrysValue('管理員帳號');
        const adjustmentAdminUserId = adminRaw ? Number(adminRaw) : null;
        // ⚠️ 保留 rawData.options 既有 key(防整包覆蓋洗掉其他設定,QC-3322 同型問題)
        const baseOptions = (this.rawData && this.rawData.options) ? this.rawData.options : {};
        const options = Object.assign({}, baseOptions, {
            eatInTemplateId, togoTemplateId, deliveryTemplateId,
            adjustmentEnabled,
            adjustmentAdminUserId,
            templateFormulas: eatInTemplateId&&togoTemplateId&&deliveryTemplateId ?
                [{"derivation":"{{IF(mealType === 'eatIn', 1, 0)}}","name":"isEatIn","function":"eval"},{"derivation":"{{IF(mealType === 'toGo', 1, 0)}}","name":"isToGo","function":"eval"},{"derivation":"{{IF(mealType === 'takeaway', 1, 0)}}","name":"isTakeaway","function":"eval"},{"derivation":"{{IF(mealType === 'delivery', 1, 0)}}","name":"isDelivery","function":"eval"},{"derivation":`{{(formulaResults.isEatIn * ${eatInTemplateId}) || (formulaResults.isToGo * ${togoTemplateId})|| (formulaResults.isTakeaway * ${togoTemplateId}) || (formulaResults.isDelivery * ${deliveryTemplateId})}}`,"name":"templateId","function":"eval"}] : undefined
        });
        const data = {
            authData,
            options,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('本店ID'),
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class Lafresh extends App {
    enable;
    id;
    constructor() {
        super('益欣', 'lafresh', LaFreshImg, 'pos', 'default');
        this.enable = false;
        this.entrys = {
            '分店ID': { value: '', type: 'input' },
            'Auth Key': { value: '', type: 'input' },
            'Access Key': { value: '67pcbag9awwfdxe19gdj1rgfb2xvny9c', type: 'input' },
            'Endpoint': { value: '', type: 'input' },
            '類型': { value: 'EC_QUICK_ORDER', type: 'tabs', 
                tabOptions: [
                    { label: "前結", value: "EC_QUICK_ORDER" },
                    { label: "後結", value: "掃碼下單" },
                ],
            },
            'Banner Type': { value: 'CATERING', type: 'tabs', 
            tabOptions: [
                    { label: "前結", value: "CATERING" },
                    { label: "後結", value: "掃碼下單" },
                ]
            },
            // ["TRADITIONAL_CHINESE","ENGLISH","JAPANESE"]
            '多語系支援-英文': { value: 'disabled', type: 'tabs',
                tabOptions: [
                    { label: "開啟", value: 'ENGLISH' },
                    { label: "關閉", value: 'disabled' },
                ],
            },
            '多語系支援-日文': { value: 'disabled', type: 'tabs',
                tabOptions: [
                    { label: "開啟", value: 'JAPANESE' },
                    { label: "關閉", value: 'disabled' },
                ],
            },
        }
        this.buttons = {
            delete: false
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        if (!data.authData) {
            this.setEntryValue('分店ID', '');
            this.setEntryValue('Auth Key', '');
            this.setEntryValue('Access Key', '');
            this.setEntryValue('Endpoint', '');
        } else {
            this.setEntryValue('分店ID', data.authData.shopId);
            this.setEntryValue('Auth Key', data.authData.authkey);
            this.setEntryValue('Access Key', data.authData.acckey);
            this.setEntryValue('Endpoint', data.authData.endpoint);
        }
        if (data.options) {
            this.setEntryValue('類型', data.options.clientDevice);
            this.setEntryValue('Banner Type', data.options.bannerType);
         
            this.setEntryValue('多語系支援-英文', data.options.languages && data.options.languages.includes("ENGLISH") ? "ENGLISH" : "disabled");
            this.setEntryValue('多語系支援-日文', data.options.languages && data.options.languages.includes("JAPANESE") ? "JAPANESE" : "disabled");
        } else {
            this.setEntryValue('多語系支援-英文', 'disabled');
            this.setEntryValue('多語系支援-日文', 'disabled');
        }
    }

    action(accountId) {
        const authData = {
            shopId: this.getEntrysValue('分店ID'),
            authkey: this.getEntrysValue('Auth Key'),
            acckey: this.getEntrysValue('Access Key'),
            endpoint: this.getEntrysValue('Endpoint')
        }
        let languages = [];
        if (this.getEntrysValue('多語系支援-英文') && this.getEntrysValue('多語系支援-英文') !== 'disabled') {
            languages.push(this.getEntrysValue('多語系支援-英文'));
        }
        if (this.getEntrysValue('多語系支援-日文') && this.getEntrysValue('多語系支援-日文') !== 'disabled') {
            languages.push(this.getEntrysValue('多語系支援-日文'));
        }
        

        const options = {
            clientDevice: this.getEntrysValue('類型'),
            bannerType: this.getEntrysValue('Banner Type'),
        }
        
        // 若有設定英/日文時，預設要把中文也加入
        if (languages.length) {
            languages.unshift("TRADITIONAL_CHINESE")
            options.languages = languages;
        } else {
            delete options.languages
        }
        const data = {
            authData,
            options,
            vendorCode: this.vendorCode,
            vendorShopId: `${authData.shopId}@${authData.authkey}`,
            env: 'production'
        }
        if (!this.rawData) {
            if (!authData.shopId || !authData.authkey) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class Geoshop extends App {
    enable;
    id;
    constructor() {
        super('社守', 'geoshop', GSImg, 'pos', 'default');
        this.enable = false;
        this.entrys = {
            'Store Email': { value: '', type: 'input' },
            '串接key設定': { value: true, type: 'checkbox'},
            'Account': { value: '', type: 'input' },
            'Password': { value: '', type: 'input' },
        }
        this.buttons = {
            delete: false
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.setEntryValue('Store Email', data.vendorShopId);
        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
            this.setEntryValue('Account', '');
            this.setEntryValue('Password', '');
        } else {
            this.setEntryValue('串接key設定', false);
            this.setEntryValue('Account', data.authData.account);
            this.setEntryValue('Password', data.authData.password);
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {
            account: this.getEntrysValue('Account'),
            password: this.getEntrysValue('Password')
        }
        const options = {};
        const data = {
            authData, 
            options,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('Store Email'),
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class TTpush extends App {
    merchantId;
    createdAt;
    url;
    constructor() {
        super('TTPUSH台東金幣', 'ttpush', TTPUSHImg, 'additionServices', 'default');
        this.active = false;
        this.entrys = {
            '開通': { value: false, type: 'switch' }
        }
        this.buttons = {
            delete: false
        };
    }

    setData(data, serviceUrl) {
        if (!data) return;
        super.setData(data);
        this.active = true;
        this.setEntryValue('開通', true);
        this.popType = 'ttpush';

        this.merchantId = data.merchantId;
        this.createdAt = moment.unix(data.createdTs).format('YYYY-MM-DD HH:mm:ss');
        this.url = serviceUrl.qpointsUrl + '&source=ttpush';
    }

    action(accountId) {
        if (!this.rawData && this.getEntrysValue('開通')) return enableService(accountId, this.vendorCode);
        else return Promise.resolve();
    }
}

export class Life17 extends App {
    liffId;
    life17StoreId;
    createdAt;
    life17ShoppingUrl;
    url;
    constructor() {
        super('寄杯券服務串接', 'life17', CupImg, 'additionServices', 'cup')
        this.active = false;
        this.buttons = {
            delete: false
        };
    }

    setData(data, serviceUrl) {
        if (data) {
            super.setData(data);
            this.active = true;
            this.popType = 'ttpush';
            
            this.life17StoreId = data.life17StoreId;
            this.createdAt = moment.unix(data.createdTs).format('YYYY-MM-DD HH:mm:ss');
            this.url = serviceUrl.life17ShoppingLiffUrl;
        } else {
            this.active = false;
            this.life17ShoppingUrl = `https://${serviceUrl.webhookUrlDomain}/line/views/auth/pick-up`;
        }
    }

    action(accountId) {
        return enableService(accountId, this.vendorCode);
    }
}

export class AppWeb extends App {
    url;
    constructor() {
        super('APP串接網址', 'app', APPImg, 'additionServices', 'app');
        this.buttons = {
            delete: false
        };
    }

    setData(data, serviceUrl) {
        this.url = serviceUrl.qpointsUrl + '&source=wemo';
    }
}

export class PosDvr extends App {
    enable;
    constructor(accountId) {
        console.log('AcconutId: ', accountId);
        super('錢都錄', 'posdvr', APPImg, 'additionServices', 'default');
        this.enable = false;
        this.entrys = {
            '本店ID': { value: `${accountId}`, type: 'input'},
            'IP位址': { value: '', type: 'input' },
            'Channel': { value: '', type: 'input' },
            'Account': { value: '', type: 'input' },
            'Password': { value: '', type: 'input' },
        }
    }

    setData(data) {
        super.setData(data);
        
        console.log('Check posdvr data: ', data);
        
        this.enable = data.enabled ? true: false;
        console.log('Data.enabled: ', data.enabled);
        // if (!data.authData) { 
        //     this.setEntryValue('串接key設定', true);
        // } else {
        //     this.setEntryValue('串接key設定', false);
        // }
        if (data.authData) {
            this.setEntryValue('Account', data.authData.account);
            this.setEntryValue('Password', data.authData.password);
            console.log('AuthData: ', data.authData);
        }
        if (data.options) {
            this.setEntryValue('IP位址', data.options.ip);
            this.setEntryValue('Channel', data.options.channel);
            console.log('Options: ', data.options);

        }
    }

    action(accountId) {
        const ip = this.getEntrysValue('IP位址');
        const channel = this.getEntrysValue('Channel');
        const account = this.getEntrysValue('Account');
        const password = this.getEntrysValue('Password');
        const authData = {
            account,
            password
        }
        const options = {
            ip,
            channel
        }
        const enabled = this
        const data = {
            authData,
            options,
            enabled
        }

        console.log('START OBJECT:');
        console.log(ip);
        console.log(channel);
        console.log(account);
        console.log(password);
        console.log('END OBJECT:');

        if (!this.rawData) {
            console.log('No data: ', accountId);
            // return createPosmw(accountId, data);
        } else {
            if (this.enable === true) {
                data.enabled = 1;
            } else {
                data.enabled = 0;
            }
            console.log(data.enabled);
            return updatePosDvrSetting(accountId, data);
        }
    }
}

export class Tyc extends App {
    merchantId;
    createdAt;
    url;
    constructor() {
        super('桃園紅利桃子', 'tyc', APPImg, 'additionServices', 'default');
        this.active = false;
        this.entrys = {
            '開通': { value: false, type: 'switch' }
        }
    }

    setData(data, serviceUrl) {
        if (!data) return;
        super.setData(data);
        this.active = true;
        this.setEntryValue('開通', true);
        this.popType = 'tyc';

        this.merchantId = data.merchantId;
        this.createdAt = moment.unix(data.createdTs).format('YYYY-MM-DD HH:mm:ss');
        this.url = serviceUrl.qpointsUrl + '&source=tyc';
    }

    action(accountId) {
        if (!this.rawData && this.getEntrysValue('開通')) return enableService(accountId, this.vendorCode);
        else return Promise.resolve();
    }
}

export class Dudoo extends App {
    enable;
    id;
    constructor() {
        super('肚肚', 'dudoo', APPImg, 'pos', 'default');
        this.enable = false;
        this.entrys = {
            '分店ID': { value: '', type: 'input' },
            'X-Api-Key': { value: '', type: 'input' },
        }
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        if (!data.authData) {
            this.setEntryValue('X-Api-Key', '');
        } else {
            this.setEntryValue('X-Api-Key', data.authData['X-Api-Key']);
        }
    }

    action(accountId) {
        const authData = {
            "X-Api-Key": this.getEntrysValue('X-Api-Key')
        }
        const data = {
            authData,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('分店ID'),
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                console.log('eee ', this.enable);
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class Kiosk extends App {
    enable;
    id;
    constructor(accountId, shopId) {
        super('Kiosk 自助結帳機', 'kiosk', APPImg, 'additionServices', 'default');
        this.enable = false;
        this.entrys = {
            '本店ID': { value: `${shopId}`, type: 'input'},
            '樣板ID': { value: '', type: 'input' },
        };
        this.buttons = {
            delete: false
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        if (data.options) {
            this.setEntryValue('樣板ID', data.options.templateId);
        }
    }

    action(accountId) {
        const templateId = parseInt(this.getEntrysValue('樣板ID'));
        const options = {
            templateId: isNaN(templateId)? undefined: templateId,
            templateFormulas: templateId && !isNaN(templateId) ? 
            [{"derivation":"{{IF(mealType === 'eatIn', 1, 0)}}","name":"isEatIn","function":"eval"},{"derivation":"{{IF(mealType === 'toGo', 1, 0)}}","name":"isToGo","function":"eval"},{"derivation":"{{IF(mealType === 'takeaway', 1, 0)}}","name":"isTakeaway","function":"eval"},{"derivation":"{{IF(mealType === 'delivery', 1, 0)}}","name":"isDelivery","function":"eval"},{"derivation":`{{(formulaResults.isEatIn * ${templateId}) || (formulaResults.isToGo * ${templateId})|| (formulaResults.isTakeaway * ${templateId}) || (formulaResults.isDelivery * ${templateId})}}`,"name":"templateId","function":"eval"}] : undefined

        }
        const data = {
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('本店ID'),
            order_integration_enabled: this.enable,
            options,
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
}

export class DongDong extends App {
    enable;
    id;
    constructor(accountId, shopId) {
        super('雲端叫號設定（動動版）', 'dongdong', APPImg, 'additionServices', 'default');
        this.enable = false;
        this.active = false
        this.entrys = {
            '開通': { value: this.active, type: 'switch' },
            '本店ID': { value: `${shopId}`, type: 'input'},
            'INTEGRATION_SOURCE': { value: '', type: 'input' },
            'STORE_ID': { value: '', type: 'input' },
            '串接key設定': { value: true, type: 'checkbox', disabled: true },
            // 'DONGDONG_QUEUING_PRIVATE_KEY': { value: '', type: 'input' },
            '樣板ID': { value: '', type: 'input' },
        };
        this.buttons = {
            delete: false
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        if (data.options) {
            this.setEntryValue('樣板ID', data.options.templateId);
            this.setEntryValue('INTEGRATION_SOURCE', data.options.integrationSource);
            this.setEntryValue('STORE_ID', data.options.storeId);
            // this.setEntryValue('DONGDONG_QUEUING_PRIVATE_KEY', data.options.queuingPrivateKey);
        }

        if (!data.authData) {
            this.setEntryValue('串接key設定', true);
        } else {
            this.setEntryValue('串接key設定', false);
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {};
        const dongdongIntegrationSource = this.getEntrysValue('INTEGRATION_SOURCE');
        const dongdongStoreId = this.getEntrysValue('STORE_ID');
        // const dongdongQueuingPrivateKey = this.getEntrysValue('DONGDONG_QUEUING_PRIVATE_KEY');

        const templateId = parseInt(this.getEntrysValue('樣板ID'));
        const options = {
            integrationSource: dongdongIntegrationSource,
            storeId: dongdongStoreId,
            // queuingPrivateKey: dongdongQueuingPrivateKey,
            templateId: isNaN(templateId)? undefined: templateId,
            templateFormulas: templateId && !isNaN(templateId) ? 
            [{"derivation":"{{IF(mealType === 'eatIn', 1, 0)}}","name":"isEatIn","function":"eval"},{"derivation":"{{IF(mealType === 'toGo', 1, 0)}}","name":"isToGo","function":"eval"},{"derivation":"{{IF(mealType === 'takeaway', 1, 0)}}","name":"isTakeaway","function":"eval"},{"derivation":"{{IF(mealType === 'delivery', 1, 0)}}","name":"isDelivery","function":"eval"},{"derivation":`{{(formulaResults.isEatIn * ${templateId}) || (formulaResults.isToGo * ${templateId})|| (formulaResults.isTakeaway * ${templateId}) || (formulaResults.isDelivery * ${templateId})}}`,"name":"templateId","function":"eval"}] : undefined

        }
               
        const data = {
            authData,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('本店ID'),
            order_integration_enabled: this.enable,
            options,
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
    setActive(value) {
        this.active = value;
        this.setEntryValue('開通', value);
    }

    switchEntryOnChange(key, accountId) {
        if (key !== '開通') return;
        const changeValue = this.getEntrysValue(key);
        this.setActive(changeValue);
        if (changeValue) return addActiveVendor(accountId, this.vendorCode);
        return removeActiveVendor(accountId, this.vendorCode);
    }
}

export class DongDongKiosk extends App {
    enable;
    id;
    constructor(accountId, shopId) {
        super('叫號取餐設定（動動版）', 'dongdong-kiosk', APPImg, 'additionServices', 'default');
        this.enable = false;
        this.active = false
        this.entrys = {
            '開通': { value: this.active, type: 'switch' },
            '本店ID': { value: `${shopId}`, type: 'input'},
            'INTEGRATION_SOURCE': { value: '', type: 'input' },
            'STORE_ID': { value: '', type: 'input' },
            '串接key設定': { value: true, type: 'checkbox', disabled: true },
            // 'DONGDONG_QUEUING_PRIVATE_KEY': { value: '', type: 'input' },
            '樣板ID': { value: '', type: 'input' },
        };
        this.buttons = {
            delete: false
        };
    }

    setData(data) {
        super.setData(data);
        this.enable = data.order_integration_enabled? true: false;
        this.id = data.id;
        if (data.options) {
            this.setEntryValue('樣板ID', data.options.templateId);
            this.setEntryValue('INTEGRATION_SOURCE', data.options.integrationSource);
            this.setEntryValue('STORE_ID', data.options.storeId);
            // this.setEntryValue('DONGDONG_QUEUING_PRIVATE_KEY', data.options.queuingPrivateKey);
        }
    }

    action(accountId) {
        const authData = this.getEntrysValue('串接key設定')? null: {};

        const dongdongIntegrationSource = this.getEntrysValue('INTEGRATION_SOURCE');
        const dongdongStoreId = this.getEntrysValue('STORE_ID');
        // const dongdongQueuingPrivateKey = this.getEntrysValue('DONGDONG_QUEUING_PRIVATE_KEY');

        const templateId = parseInt(this.getEntrysValue('樣板ID'));
        const options = {
            integrationSource: dongdongIntegrationSource,
            storeId: dongdongStoreId,
            // queuingPrivateKey: dongdongQueuingPrivateKey,
            templateId: isNaN(templateId)? undefined: templateId,
            templateFormulas: templateId && !isNaN(templateId) ? 
            [{"derivation":"{{IF(mealType === 'eatIn', 1, 0)}}","name":"isEatIn","function":"eval"},{"derivation":"{{IF(mealType === 'toGo', 1, 0)}}","name":"isToGo","function":"eval"},{"derivation":"{{IF(mealType === 'takeaway', 1, 0)}}","name":"isTakeaway","function":"eval"},{"derivation":"{{IF(mealType === 'delivery', 1, 0)}}","name":"isDelivery","function":"eval"},{"derivation":`{{(formulaResults.isEatIn * ${templateId}) || (formulaResults.isToGo * ${templateId})|| (formulaResults.isTakeaway * ${templateId}) || (formulaResults.isDelivery * ${templateId})}}`,"name":"templateId","function":"eval"}] : undefined

        }

        const data = {
            authData,
            vendorCode: this.vendorCode,
            vendorShopId: this.getEntrysValue('本店ID'),
            order_integration_enabled: this.enable,
            options,
            env: 'production'
        }
        if (!this.rawData) {
            if (!data.vendorShopId || !data.vendorShopId.length) {
                let e = new Error('請先設定資料後再開通');
                e.code = 'SHOP_ID_IS_REQUIRED';
                throw e;
            }
            return createPosmw(accountId, data);
        } else {
            data.env = this.rawData.env;
            data.id = this.rawData.id;
            data.order_integration_enabled = this.enable;
            return updatePosmw(accountId, data.id, data);
        }
    }
    setActive(value) {
        this.active = value;
        this.setEntryValue('開通', value);
    }

    switchEntryOnChange(key, accountId) {
        if (key !== '開通') return;
        const changeValue = this.getEntrysValue(key);
        this.setActive(changeValue);
        if (changeValue) return addActiveVendor(accountId, this.vendorCode);
        return removeActiveVendor(accountId, this.vendorCode);
    }
}

// export class KabobTico extends App {
//     url;
//     constructor() {
//         super('Tico Go', 'ticogo', APPImg, 'additionServices', 'default');
//     }

//     setData(data, serviceUrl) {
//         this.url = serviceUrl.qpointsUrl + '&source=wemo';
//     }
// }

